// src/Header.jsx
import React from 'react';
import './Header.css'; // Opcional: si el header tiene sus propios estilos
import rotoplasLogo from '../assets/rotoplas-logo.png';

const Header = ({ total }) => {
  return (
    <div className="header-container">
      <div className="logo-rotoplas">
        <img src={rotoplasLogo} alt="Rotoplas Logo" />
      </div>
    </div>
  );
};

export default Header;